
const getCollectionNameUtil = ({ productVariant }) => {
  return productVariant?.brand || productVariant?.vendor
}

export default getCollectionNameUtil
